import React, { useState } from 'react';
import styles from './clientFcbDocument.module.css';
import formStyles from '../../../../components/Form/form.module.css';
import HookForm from '../../../../components/HookForm/HookForm';
import Button from '../../../../components/Button/Button';
import Hint from '../../../../components/Hint';
import pkbFcbSendCode from '../../../../api/clients/pkbFcbSendCode';
import pkbFcbGetDocument from '../../../../api/clients/pkbFcbGetDocument';
import alert from '../../../../helpers/alert';
import { textStyles } from '../../../../constants/textStyles';

const smsCodeMask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/];

const howItWorksHint = (
<div style={{ display: 'flex', flexDirection: 'column', gap: 10, minWidth: 220 }}>
<div style={{ display: 'flex', gap: 8 }}>
<span style={{ fontWeight: 700, color: '#b8894f' }}>1.</span>
<span>ÐÑÐ¿ÑÐ°Ð²Ð»ÑÐµÐ¼ SMS-ÐºÐ¾Ð´ ÐºÐ»Ð¸ÐµÐ½ÑÑ Ð½Ð° ÑÐºÐ°Ð·Ð°Ð½Ð½ÑÐ¹ Ð½Ð¾Ð¼ÐµÑ</span>
</div>
<div style={{ display: 'flex', gap: 8 }}>
<span style={{ fontWeight: 700, color: '#b8894f' }}>2.</span>
<span>ÐÐ»Ð¸ÐµÐ½Ñ Ð½Ð°Ð·ÑÐ²Ð°ÐµÑ ÐºÐ¾Ð´ Ð¸Ð· SMS</span>
</div>
<div style={{ display: 'flex', gap: 8 }}>
<span style={{ fontWeight: 700, color: '#b8894f' }}>3.</span>
<span>ÐÐ°Ð½Ð½ÑÐµ ÑÐ´Ð¾ÑÑÐ¾Ð²ÐµÑÐµÐ½Ð¸Ñ Ð»Ð¸ÑÐ½Ð¾ÑÑÐ¸ Ð¿Ð¾Ð´Ð³ÑÑÐ·ÑÑÑÑ Ð² ÑÐ¾ÑÐ¼Ñ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ¾Ð²</span>
</div>
</div>
);

const ClientFcbDocument = ({ clientId, iin, phone, onSuccess, embedded }) => {
const [phase, setPhase] = useState('idle');
const [requestId, setRequestId] = useState(null);
const [code, setCode] = useState('');
const [errorMessage, setErrorMessage] = useState('');
const [expired, setExpired] = useState(false);
const [result, setResult] = useState(null);

const iinDigits = (iin || '').replace(/\D/g, '');
const phoneDigits = (phone || '').replace(/\D/g, '');
const canStart = iinDigits.length === 12 && phoneDigits.length > 0;

const sendCode = async () => {
if (!canStart) {
alert.error('ÐÐ»Ñ Ð·Ð°Ð¿ÑÐ¾ÑÐ° Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ° Ð½ÑÐ¶Ð½Ñ ÐºÐ¾ÑÑÐµÐºÑÐ½ÑÐµ ÐÐÐ Ð¸ ÑÐµÐ»ÐµÑÐ¾Ð½ ÐºÐ»Ð¸ÐµÐ½ÑÐ°');
return;
}
setPhase('sending');
setErrorMessage('');
setExpired(false);
try {
const res = await pkbFcbSendCode(clientId);
if (res?.data?.success) {
setRequestId(res.data.requestId);
setCode('');
setPhase('codeSent');
} else {
setErrorMessage(res?.data?.errorMessage || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¾ÑÐ¿ÑÐ°Ð²Ð¸ÑÑ SMS-ÐºÐ¾Ð´');
setPhase('error');
}
} catch (e) {
setErrorMessage(e?.response?.data?.errorMessage || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¾ÑÐ¿ÑÐ°Ð²Ð¸ÑÑ SMS-ÐºÐ¾Ð´');
setPhase('error');
}
};

const confirmCode = async () => {
const digits = (code || '').replace(/\D/g, '');
if (digits.length !== 6) {
alert.error('ÐÐ²ÐµÐ´Ð¸ÑÐµ 6-Ð·Ð½Ð°ÑÐ½ÑÐ¹ ÐºÐ¾Ð´ Ð¸Ð· SMS');
return;
}
setPhase('checking');
setErrorMessage('');
try {
const res = await pkbFcbGetDocument(clientId, { requestId, code: digits });
if (res?.data?.success) {
setResult(res.data);
setPhase('success');
alert.success(res.data.message || 'ÐÐ¾ÐºÑÐ¼ÐµÐ½Ñ Ð¿Ð¾Ð»ÑÑÐµÐ½');
onSuccess && onSuccess();
} else {
const message = res?.data?.errorMessage || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¿Ð¾Ð»ÑÑÐ¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ';
setErrorMessage(message);
setExpired(/Ð¿ÑÐ¾ÑÑÐ¾ÑÐµÐ½|Ð¸ÑÑÑÐº|Ð¸ÑÑÐµÐº/i.test(message));
setPhase('error');
}
} catch (e) {
const message = e?.response?.data?.errorMessage || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¿Ð¾Ð»ÑÑÐ¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ';
setErrorMessage(message);
setExpired(/Ð¿ÑÐ¾ÑÑÐ¾ÑÐµÐ½|Ð¸ÑÑÑÐº|Ð¸ÑÑÐµÐº/i.test(message));
setPhase('error');
}
};

const retry = () => {
setPhase('idle');
setErrorMessage('');
setCode('');
};

const codeInputs = [
{
name: 'code',
label: 'ÐÐ¾Ð´ Ð¸Ð· SMS',
placeholder: '_ _ _ _ _ _',
mask: smsCodeMask,
},
];

return (
<div
className={embedded ? undefined : formStyles.borderWrapper}
style={embedded ? { marginBottom: 16 } : { margin: 0 }}
>
{!embedded && (
<div style={{ display: 'flex', alignItems: 'center', columnGap: 20, marginBottom: 16 }}>
<p style={textStyles.formTitle}>
ÐÐ¾Ð»ÑÑÐµÐ½Ð¸Ðµ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ¾Ð² ÐºÐ»Ð¸ÐµÐ½ÑÐ°
<Hint text={howItWorksHint} />
</p>
</div>
)}

{phase === 'idle' && (
<div className={styles.row}>
<p className={styles.hintText}>
ÐÐ°Ð¿ÑÐ¾ÑÐ¸Ð¼ Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ° SMS-ÐºÐ¾Ð´ Ð¸ Ð·Ð°Ð¿Ð¾Ð»Ð½Ð¸Ð¼ Ð´Ð°Ð½Ð½ÑÐµ ÑÐ´Ð¾ÑÑÐ¾Ð²ÐµÑÐµÐ½Ð¸Ñ Ð»Ð¸ÑÐ½Ð¾ÑÑÐ¸ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸
</p>
<Button text="ÐÑÐ¿ÑÐ°Ð²Ð¸ÑÑ SMS-ÐºÐ¾Ð´" fill onClick={sendCode} disabled={!canStart} />
{!canStart && <p className={styles.warnText}>ÐÑÐ¾Ð²ÐµÑÑÑÐµ ÐÐÐ Ð¸ ÑÐµÐ»ÐµÑÐ¾Ð½ ÐºÐ»Ð¸ÐµÐ½ÑÐ° Ð² Ð±Ð»Ð¾ÐºÐµ Ð²ÑÑÐµ</p>}
</div>
)}

{phase === 'sending' && (
<div className={styles.row}>
<span className={styles.spinner} />
<p className={styles.hintText}>ÐÑÐ¿ÑÐ°Ð²Ð»ÑÐµÐ¼ SMS-ÐºÐ¾Ð´â¦</p>
</div>
)}

{(phase === 'codeSent' || phase === 'checking') && (
<div className={styles.row}>
<HookForm
inputs={codeInputs}
grid={{ display: 'grid', rowGap: 12, margin: 0, maxWidth: 220 }}
style={{ margin: 0, padding: 0, backgroundColor: 'transparent' }}
onValuesChange={(values) => setCode(values.code)}
/>
<Button
text="ÐÐ¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÑ ÐºÐ¾Ð´"
fill
onClick={confirmCode}
disabled={phase === 'checking' || (code || '').replace(/\D/g, '').length !== 6}
/>
<span className={styles.manualLink} onClick={sendCode}>
ÐÑÐ¿ÑÐ°Ð²Ð¸ÑÑ ÐºÐ¾Ð´ Ð¿Ð¾Ð²ÑÐ¾ÑÐ½Ð¾
</span>
</div>
)}

{phase === 'success' && (
<div className={styles.row}>
<p className={styles.successText}>
ÐÐ¾ÐºÑÐ¼ÐµÐ½Ñ Ð¿Ð¾Ð»ÑÑÐµÐ½{result?.documentNumber ? `: â ${result.documentNumber}` : ''}
</p>
{result?.updatedFields?.length > 0 && (
<p className={styles.hintText}>ÐÐ±Ð½Ð¾Ð²Ð»ÐµÐ½Ñ Ð¿Ð¾Ð»Ñ: {result.updatedFields.join(', ')}</p>
)}
<span className={styles.manualLink} onClick={retry}>
ÐÐ°Ð¿ÑÐ¾ÑÐ¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ ÐµÑÑ ÑÐ°Ð·
</span>
</div>
)}

{phase === 'error' && (
<div className={styles.row}>
<p className={styles.errorText}>{errorMessage}</p>
<Button text={expired ? 'ÐÐ°Ð¿ÑÐ¾ÑÐ¸ÑÑ Ð½Ð¾Ð²ÑÐ¹ ÐºÐ¾Ð´' : 'ÐÐ¾Ð¿ÑÐ¾Ð±Ð¾Ð²Ð°ÑÑ ÐµÑÑ ÑÐ°Ð·'} fill onClick={retry} />
</div>
)}
</div>
);
};

export default ClientFcbDocument;